/* eslint-disable */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Title } from '../style';

const Cgu = () => {
  return (
    <Grid container alignItems="center" justify="center">
      <Grid item md={8} style={{ textAlign: 'center' }}>
        <Title>Conditions générales d&lsquo;utilisation Sympl</Title>
      </Grid>
      <Grid item md={8}>
        <h3>Préambule</h3>
        <p>
          L’Application Sympl est éditée par la société SAS DAT, société par
          actions simplifiée, immatriculée au Registre du commerce et des
          Sociétés de Paris sous le numéro 827776162, siégeant au 259, rue Saint
          Honoré — 75001 Paris, et représentée par son Président Monsieur
          Philippe Allouche, (ci-après « SYMPL »).
        </p>
        <h3>1. Glossaire & définitions</h3>
        <p>
          Les mots ci-dessous, dont la première lettre est en majuscules, seront
          définis comme tels dans les présentes conditions générales :
        </p>
        <strong>Conditions générales de vente :</strong> conditions
        contractuelles dans le cadre desquelles s’effectue l’intégralité du
        service proposé par SYMPL.
        <p>
          <strong>Conditions générales d’utilisation :</strong> conditions
          d’utilisation de l’Application Sympl.
        </p>
        <p>
          <strong>Application :</strong> désigne l’Application logicielle Sympl,
          éditée par le Prestataire et installée sur le téléphone mobile du
          Client, à l’initiative de ce dernier
        </p>
        <p>
          <strong>Client :</strong> personne utilisant l’un des produits
          développés par Sympl (module, Applications). Le Client passe commande
          en son nom, ou pour le compte d’une personne morale.
        </p>
        <p>
          <strong>Commande :</strong> désigne l’achat par le Client de la
          prestation de service proposée par SYMPL à savoir : récupération du ou
          des Objets du Client par le Coursier, son emballage par SYMPL et sa
          livraison par un Partenaire de SYMPL à l’adresse désignée par le
          Client.
        </p>
        <p>
          <strong>Coursier :</strong> désigne l’entité ou la personne
          responsable du retrait de la marchandise du Client, à l’adresse qu’il
          aura indiquée.
        </p>
        <p>
          <strong>Entrepôt :</strong> désigne le ou les locaux occupés par SYMPL
          dans lesquels les objets confiés par les clients sont pesés,
          conditionnés et remis aux Transporteurs.
        </p>
        <p>
          <strong>Objet :</strong> désigne les objets, produits ou marchandises
          que les Clients font livrer en utilisant les services proposés par
          SYMPL.
        </p>
        <p>
          <strong>Partenaire :</strong> désigne l’ensemble des transporteurs
          partenaires utilisés par Sympl.
        </p>
        Les transporteurs sont La Poste, Colissimo, Chronopost, DPD France, TNT,
        DHL, UPS, Colis Privé. Cette liste est susceptible d’évoluer. Notre
        système informatique sélectionne le partenaire adéquat en fonction des
        caractéristiques de la commande et du mode de livraison choisi par le
        Client.
        <p>
          <strong>Politique de confidentialité :</strong> règles relatives à
          l’exploitation des données personnelles des Clients du site. La
          Politique de confidentialité détaille l’utilisation faite des données
          personnelles du Client du site, ainsi que les droits dont il dispose
          sur ces données.
        </p>
        <p>
          <strong>Prix :</strong> prix total du service proposé par SYMPL. Les
          prix sont entendus toutes taxes comprises pour les particuliers.
        </p>
        <p>
          <strong>Service :</strong> désigne l’ensemble des prestations fournies
          par SYMPL
        </p>
        <p>
          <strong>Transporteur :</strong> désigne la société sélectionnée et
          mise en relation avec le Client par l’intermédiaire de SYMPL qui sera
          chargée de la livraison de ou des produits confiés de l’Entrepôt SYMPL
          à l’adresse déterminée par l’utilisateur.
        </p>
        <p>
          <strong>Validation de la commande :</strong> acceptation de la
          commande passée par le Client de l’Application.
        </p>
        <h3>2. Champs d'application</h3>
        <p>
          Les présentes conditions générales d’utilisation s’appliquent, sans
          restriction ni réserve à tout achat des Services décrits à l’article 3
          ci-dessous proposés par la société SYMPL aux Clients non
          professionnels sur son Application SYMPL.
        </p>
        <p>
          Les caractéristiques principales des Services sont présentées sur
          l’Application SYMPL. Le Client est tenu d’en prendre connaissance
          avant toute passation de commande, le choix et l’achat d’un service
          étant de la seule responsabilité du Client. Les présentes Conditions
          Générales d’Utilisation s’appliquent à l’exclusion de tous autres
          conditions.
        </p>
        <p>
          Elles sont accessibles à tout moment sur l’Application et prévaudront,
          le cas échéant, sur toute autre version ou tout autre document
          contradictoire.
        </p>
        <p>
          Le Client déclare avoir pris connaissance des présentes Conditions
          Générales d’Utilisation de l’Application et les avoir acceptées en
          cochant la case prévue à cet effet avant la validation de la procédure
          de commande en ligne.
        </p>
        <p>
          La validation de la commande de Service par le Client vaut acceptation
          sans restriction ni réserve des présentes Conditions Générales
          d’Utilisation.
        </p>
        <p>
          Ces conditions pouvant faire l’objet de modifications ultérieures, la
          version applicable à la Commande du Client est celle en vigueur sur le
          site internet à la date de passation de la Commande.
          <br />
          <br />
          Le Client reconnaît avoir la capacité requise pour contracter et
          acquérir les services proposés sur l’appli SYMPL.
          <br />
          <br />
          Si l’une des clauses s’avérait, pour quelque raison que ce soit,
          inapplicable, nulle ou non valide, le retrait de ladite disposition
          n’affecterait pas la validité et l’opposabilité des autres
          stipulations du contrat dans son ensemble.
          <br />
          <br />
          Sauf preuve contraire, les données enregistrées dans le système
          informatique du prestataire constituent la preuve de l’ensemble de la
          transaction conclue avec le Client.
        </p>
        <h3>3. Objet du service Sympl</h3>
        <p>
          Le service Sympl a pour vocation de proposer une solution logistique à
          la demande simplifiée, en permettant aux particuliers d’externaliser
          leur système logistique.
        </p>
        <p>
          Sympl mandate au nom et pour le compte du Client un Coursier pour
          acheminer l’Objet au sein de son Entrepôt, se charge de l’emballage de
          l’Objet puis sélectionne mandate au nom et pour le compte du Client un
          commissionnaire de transport ou un Transporteur pour livrer l’Objet à
          l’adresse de livraison indiquée par le Client.
        </p>
        <p>
          Sympl fournit ce Service via l’Application et le module SYMPL mais n’a
          pas en aucun cas la qualité de commissionnaire de transport ou de
          transporteur.
        </p>
        <h3>4. Utilisation du site & déroulement de l’envoi</h3>
        <p>
          L’utilisation de l’Application suit les étapes décrites comme suit :{' '}
        </p>
        <p>
          1/ Le Client se connecte sur son compte via son adresse mail et son
          numéro de téléphone. Il reçoit un code de confirmation de six chiffres
          par SMS sur son téléphone. Il saisit le code de confirmation.
        </p>
        <p>
          2/ Il clique sur le lien mentionné « Nouvel envoi ». Il prend une
          photo de l’objet ou des objets à envoyer .
        </p>
        <p>
          3/ Il saisit le poids estimatif de l’objet. Plus le poids saisi est
          précis, plus le prix fourni par l’Application sera précis également.
        </p>
        <p>
          4/ Il sélectionne les informations nécessaires concernant ses objets
          et le mode de livraison choisi :
        </p>
        <ul>
          <li>Format de l’objet : documents, petit colis, grand colis</li>
          <li>Type de l’objet : standard, fragile, précieux</li>
          <li>Mode de livraison : point relais, entreprise, particulier</li>
        </ul>
        <p>
          5/ Il choisit la valeur déclarée pour assurer son objet et ses objets.
        </p>
        <p>
          6/ Il choisit le mode de livraison : standard, avec signature,
          express, express plus, relais.
        </p>
        <p>
          Il est de la seule et entière responsabilité du Client de fournir
          toutes les informations de manière juste, complète et correcte, afin
          de permettre à SYMPL et ses partenaires de procéder à l’exécution des
          Services proposés. SYMPL décline toute responsabilité en cas d’erreurs
          dans les informations communiquées par le Client, si les informations
          communiquées se révélaient erronées et qu’elles ne permettaient pas
          l’exécution, par SYMPL, des Services de transport sélectionnés. Le
          Client s’engage ainsi à supporter toute conséquence pécuniaire
          résultant d’une information erronée ou incomplète. De même, dans le
          cas où le Client aurait fourni une adresse erronée ou incomplète ne
          permettant pas la bonne exécution des Services de transport commandés,
          ceux-ci seront réputés exécutés. Dans cette hypothèse, une pénalité
          sera appliquée et automatiquement prélevée sur la somme bloquée sur le
          compte bancaire du Client conformément aux stipulations de l’article 9
          ci-après.
        </p>
        <p>
          7/ Il indique l’adresse d’enlèvement à laquelle le Coursier doit
          collecter le ou les objets et clique sur le lien mentionné « demander
          un Coursier ».
        </p>
        <p>
          8/ Un message de Validation de la commande apparaît sur son écran. La
          Validation de la commande intervient après acceptation des présentes
          Conditions générales. La Validation de la commande constitue une
          signature électronique de valeur équivalente à celle d’une signature
          manuscrite.
        </p>
        <p>
          9/ Il complète les coordonnées du destinataire, son nom, son adresse,
          son adresse mail et son numéro de téléphone ou il choisit un
          destinataire dans son carnet d’adresses.
        </p>
        <p>
          10/ Il complète les coordonnées du destinataire, son nom, son adresse,
          son adresse mail et son numéro de téléphone ou il choisit un
          destinataire dans son carnet d’adresses.
        </p>
        <p>
          Le Client s’engage à être présent à l’adresse indiquée. S’il s’avérait
          absent, le Coursier tentera de le joindre par téléphone au numéro
          indiqué lors de la commande sur l’Application. L’attente ne saurait
          excéder cinq (5) minutes, après lesquelles le Coursier pourra quitter
          le lieu de retrait et considérer la commande comme honorée. La
          pénalité prévue à l’article 9 ci-après sera alors appliquée.{' '}
        </p>
        <p>
          Le Client s’engage à fournir ses meilleurs efforts afin de précisément
          séparer les commandes les unes des autres. A défaut, SYMPL se réserve
          le droit d’en refuser la collecte. SYMPL décline toute responsabilité
          quant à une éventuelle erreur effectuée dans les envois de commande
          dès lors qu’elle serait la conséquence directe d’un défaut
          d’individualisation des produits du Client. Le Client s’engage à
          fournir des informations justes et réelles sur ses marchandises,
          notamment (sans que cette liste soit exhaustive) sur la quantité et la
          valeur des produits. Le Client s’engage à ne pas demander l’exécution
          des Services proposés par SYMPL pour des produits interdits par
          l’article 8 des présentes Conditions générales de vente et
          d’utilisation.
        </p>
        <p>Le Client procède à la remise de ses marchandises au Coursier.</p>
        <p>
          12/ La marchandise est acheminée au sein de l’Entrepôt de SYMPL, qui
          procèdera à son emballage. SYMPL s’engage à fournir ses meilleurs
          efforts afin d’assurer un emballage adapté sur mesure à la commande.
        </p>
        <p>
          13/ SYMPL transmet le colis emballé au Transporteur partenaire choisi
          par SYMPL selon les informations transmises par le Client lors de sa
          commande sur l’Application.
        </p>
        <p>
          14/ Le Transporteur achemine le colis à la destination indiquée par le
          Client sur l’Application. Le Client s’engage à fournir des adresses
          précises et réelles de destination. SYMPL ne pourra être tenu
          responsable en cas d’échec de livraison d’un de ses partenaires. Si
          l’adresse correspond à celle d’un professionnel, au moins un membre du
          personnel doit être présent aux heures normales de bureau pour
          réceptionner l’envoi.
        </p>
        <p>
          Dès la prise en charge du colis par le transporteur sélectionné, le
          client est informé de son identité et peut suivre l’évolution de son
          envoi sur le site de ce dernier grâce aux références et codes qui lui
          sont communiqués.
        </p>
        <p>
          Si pour une raison indépendante de la volonté du transporteur, la
          livraison ne pouvait pas être réalisée, notamment l’absence de
          destinataire à l’adresse indiquée, un avis de passage sera déposé sur
          lequel sera indiqué le lieu où l’Objet pourra être retiré. A défaut de
          retrait de l’Objet dans un délai de 10 jours à compter du dépôt de
          l’avis de passage, l’Objet sera réexpédié dans les locaux de SYMPL. Le
          Client pourra lors venir de récupérer sous réserve de régler les
          pénalités prévues à l’article 9 ci-dessous.
        </p>
        <p>
          Si l’Objet venait à ne pas être réclamé ni récupéré dans un délai de 6
          mois à compter de sa restitution à SYMPL, SYMPL est d’ores et déjà
          autorisé à le détruire ou le vendre.
        </p>
        <h3>LIVRAISONS INTERNATIONALES</h3>
        <p>
          Les commandes présentées sur l’Application SYMPL peuvent être envoyées
          vers tous les pays du monde. Des droits de douanes ou autres taxes
          locales ou droits d’importation ou taxes d’état sont susceptibles
          d’être exigibles. Ils seront à la charge et relèvent de la seule
          responsabilité du Client.
        </p>
        <h4>5. Engagements du Client</h4>
        <p>
          Le Client s’engage à se conformer aux dispositions des présentes
          Conditions générales ainsi que celles des partenaires de SYMPL. Le
          Client s’engage également à respecter les lois et règlements en
          vigueur dans tous les pays concernés par le transport des produits
          acheminés par les Services de SYMPL.
        </p>
        <p>
          Le Client s’engage à ne pas perturber ou entraver le bon
          fonctionnement de l’Application.
        </p>
        <p>
          Le Client s’engage à fournir les informations exactes nécessaires à
          l’utilisation de l’Application, pour son compte, comme tout tiers
          empruntant ses données. Toutes les données récoltées sur l’Application
          relative à l’exécution des Services constituent des preuves recevables
          et opposables entre les parties dans le cadre d’une procédure
          judiciaire.
        </p>
        <p>
          Le Client s’engage à n’entraver aucun droit de propriété
          intellectuelle de tiers.
        </p>
        <p>
          Le Client s’engage à ne pas usurper l’identité d’un autre Client de
          l’Application, et à respecter la vie privée d’autrui
        </p>
        <p>
          Le Client s’engage à ne pas porter atteinte à l’intégrité de
          l’Application, et à ne pas collecter d’information personnelle sur un
          autre Client.
        </p>
        <p>
          Le Client s’engage à payer les sommes dues suite à sa commande. Le
          Client est responsable du paiement de sa commande. Le Client est
          également responsable du paiement effectué pour le compte d’un mineur,
          ou d’un tiers.
        </p>
        <p>
          Le Client s’engage à ne faire qu’un usage strictement personnel des
          Services de SYMPL. La revente des Services à un tiers est strictement
          prohibée. Chaque compte Client SYMPL, nom du Client et mot de passe,
          sont strictement personnels ; le Client s’engage à ne pas les
          divulguer à un tiers. Le Client s’engage à ne pas céder ou transférer
          le compte Client, nom du Client et mot de passe, à un tiers, personne
          physique ou morale. La confidentialité et la fiabilité du mot de passe
          et du nom du Client sont de l’unique responsabilité de le Client.
        </p>
        <p>
          Le Client s’engage à fournir toute preuve d’identité si SYMPL le juge
          raisonnablement opportun et nécessaire.
        </p>
        <p>
          Le Client s’engage à utiliser l’Application et le module en conformité
          avec sa finalité.
        </p>
        <p>
          Le Client s’engage à ne pas utiliser le Service à des fins de nuisance
          envers un tiers.
        </p>
        <p>
          Le Client s’engage à ne pas copier ou distribuer le contenu de SYMPL,
          de quelque manière que ce soit, sans avoir préalablement obtenu
          l’accord écrit de ses dirigeants.
        </p>
        <h3>6. Refus légitime de commande</h3>
        <p>
          SYMPL se réserve le droit de refuser le traitement de certaines
          commandes, notamment si elles émanent d’un Client insolvable et/ou
          avec lequel SYMPL a précédemment rencontré des différents dans le
          paiement de ses Services. Il en est de même en cas de violation des
          présentes Conditions générales. SYMPL se réserve le droit de refuser
          le traitement de commandes si, malgré ses efforts, elle est dans
          l’impossibilité de permettre l’acheminement des colis, notamment du
          fait d’un cas de force majeure imprévisible, irrésistible, extérieure.
          SYMPL se réserve également le droit de ne pas traiter les commandes
          relevant d’une tentative de fraude, ou du transport d’objets illicites
          tels que définis ci-dessous. SYMPL se réserve le droit de refuser le
          traitement des commandes dont les informations requises révélaient la
          présence de propos injurieux, inacceptables, ou illégaux. SYMPL
          informe son Client que ne pourront être pris en charge, sans que cette
          liste soit exhaustive : les bijoux et articles d’horlogerie composés
          même partiellement de pierres et métaux précieux, les pierres et
          métaux précieux, les monnaies, devises, billets de banque, valeurs
          financières, titres ou moyens de paiement et notamment les effets de
          commerce, les cartes téléphoniques, chèques cadeaux, ou tout autres
          support permettant un paiement fongible, l’intégralité des articles
          relevant des dispositions des règlementations nationales et
          internationales sur les produits dangereux comme, sans que cette liste
          soit exhaustive: les gaz, munitions, matières inflammables,
          radioactives, toxiques, infectieuses ou corrosives. Ne peuvent
          également être pris en charge les animaux ou êtres vivants ou morts,
          les marchandises soumises à une certaine température, les denrées
          périssables, les armes à feu ou armes de guerre ou de collection, les
          objets d’art ou antiquités, tout objet qui par leur conditionnement ou
          nature sont susceptibles de présenter un danger pour le personnel de
          transport ou de logistique, les véhicules ou engins de transport, les
          tiers. SYMPL refusera également l’acheminement des supports
          audiovisuels interdits par toute loi ou règlementation applicable,
          tout produit contrefait ou issu de la contrefaçon. Sont également
          refusés les objets immoraux, les médicaments, le tabac, les
          stupéfiants, les matières psychotropes, les cendres ou reliques
          funéraires. En cas de violation de l’une de ces dispositions, SYMPL se
          réserve le droit d’abandonner l’acheminement de tout colis, et le
          Client s’engage à indemniser SYMPL de toutes les conséquences
          résultant de cette violation dans les conditions prévues à l’article 9
          ci-après.
        </p>
        <h3>7. Rétractation, modification, annulation de la commande</h3>
        <p>
          Compte tenu de la nature du service fourni, le Client reconnaît être
          informé par les présentes Conditions générales, qu’en vertu des
          dispositions de l’article L. 121-20-4 du Code de la consommation, les
          Services de transport proposés par SYMPL ne sont pas soumis au droit
          de rétractation prévu aux articles L. 121-20 et suivants du même Code.
          Les présentes Conditions générales régissent toute rétractation,
          modification ou annulation de la commande effectuée sur l’Application.
        </p>
        <p>
          Toute annulation ou modification survenue plus d’un quart d’heure
          après la commande du Coursier entrainera la facturation du prix du
          Service soit 5 € par lot de 10 objets. Les commandes ne pourront être
          ni annulées ni modifiées après la prise en charge des colis par le
          Partenaire. Toute modification de la commande est susceptible d’en
          modifier le prix. En procédant à la modification de sa commande, le
          Client est réputé accepter le nouveau calcul de prix. L’annulation ou
          la modification de la commande n’est effective que lorsque le Client
          en aura reçu une confirmation dans l’Application ou par courriel.
        </p>
      </Grid>
    </Grid>
  );
};

export default Cgu;
